/* @jsx h */
import { labels } from '../config';
import { useEffect, useState, useRef } from 'preact/hooks';
import { DayPicker } from 'react-day-picker';
import { useDebounce } from 'use-debounce';
import 'react-day-picker/dist/style.css';
import { de } from 'date-fns/locale';

const DateRangePicker = ({
  label,
  dateFilterObj,
  triggerAjaxSubmit,
  pluginNamespace,
  isReset,
}) => {
  const [dateInput, setDateInput] = useState('');
  const datepickerInputEl = useRef(null);
  const daypickerEl = useRef(null);
  const [range, setRange] = useState({});
  const [debouncedRange] = useDebounce(range, 600);
  const [activeRange, hasActiveRange] = useState(false);

  useEffect(() => {
    if (!range?.to) return;
    if (!range?.from) return;
    const rangeFrom = `${range?.from?.getFullYear()}${(
      range?.from?.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}${range?.from
      ?.getDate()
      .toString()
      .padStart(2, '0')}0000`;

    const rangeTo = `${range?.to?.getFullYear()}${(range?.to?.getMonth() + 1)
      .toString()
      .padStart(2, '0')}${range?.to
      ?.getDate()
      .toString()
      .padStart(2, '0')}2359`;

    // convert into correct datestring
    const dateString = `${dateFilterObj.name}:${rangeFrom}-${rangeTo}`;

    setDateInput(`${dateString}`);
  }, [debouncedRange]);

  useEffect(() => {
    if (range) {
      hasActiveRange(false);
      setRange(undefined);
    }
  }, [isReset]);

  useEffect(() => {
    if (dateInput) {
      hasActiveRange(true);
      // trigger submit
      triggerAjaxSubmit();
    }
  }, [dateInput]);

  function handleButtonClick() {
    const target = daypickerEl.current;
    target.classList.toggle('is-open');
  }

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        const target = daypickerEl.current;
        if (ref.current && !ref.current.contains(event.target)) {
          target.classList.remove('is-open');
        }
      }
      // Bind the event listener
      document.addEventListener('click', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('click', handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(daypickerEl);

  return (
    <div className="search-datepicker" ref={daypickerEl}>
      <button
        class="search-datepicker__open-button"
        type="button"
        onClick={handleButtonClick}
      >
        <h3 class="search-datepicker__label">
          {label || 'Zeitraum'}
          {activeRange ? (
            <span class="search-form__selection-indicator">
              <span class="sr-only">{labels.faceting.filterActive}</span>
            </span>
          ) : (
            ''
          )}
        </h3>
        <span class="icon icon--dropdown search-datepicker__open-button-icon">
          <svg class="icon__svg" role="img" aria-hidden="true">
            <use href="#icon-dropdown" />
          </svg>
        </span>
      </button>
      <label for="dateRangePicker" className="sr-only">
        <input
          id="dateRangePicker"
          name={`${pluginNamespace}[filter][]`}
          type="text"
          ref={datepickerInputEl}
          value={dateInput}
          tabindex="-1"
        />
      </label>
      <div className={`search-datepicker__daypicker`}>
        <DayPicker
          mode="range"
          selected={range}
          onSelect={setRange}
          locale={de}
          captionLayout="dropdown-buttons"
          fromYear={2016}
          toYear={new Date().getFullYear() + 2}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
